import { Injectable } from '@angular/core';
import {
    CanLoad,
    CanActivate,
    CanActivateChild,
    Router,
} from '@angular/router';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AuthService } from '../../core';

@Injectable()
export class IsLoggedGuard implements CanLoad, CanActivate, CanActivateChild {
    user$: Observable<boolean>;

    constructor(private authService: AuthService, private router: Router) {}

    checkIfUserIsAuthenticated() {
        this.user$ = this.authService.isAuthenticated$;

        return this.user$.pipe(
            tap(user => {
                if (user) {
                    return true;
                } else {
                    this.router.navigate(['/login']);
                    return false;
                }
            }),
        );
    }

    canLoad(): Observable<boolean> | Promise<boolean> | boolean {
        return this.checkIfUserIsAuthenticated();
    }

    canActivate(): Observable<boolean> | Promise<boolean> | boolean {
        return this.checkIfUserIsAuthenticated();
    }

    canActivateChild(): Observable<boolean> | Promise<boolean> | boolean {
        return this.checkIfUserIsAuthenticated();
    }
}
